"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-use-before-define */
exports.default = (function () {
    var errorStore = [];
    return {
        push: pushError,
        get: getError,
        clear: clear,
    };
    function pushError(error) {
        errorStore.push(error);
    }
    function getError() {
        return errorStore;
    }
    function clear() {
        errorStore = [];
    }
});
//# sourceMappingURL=EventErrorReport.js.map